export const promoTypes = {
    buy_x_get_y: "buy_x_get_y",
    promo_code: "promo_code",
    universal: "universal"
}